import { SET_USER_PROBLEM_DATA } from "./types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setUserProblemData = (data: any) => ({
  payload: data,
  type: SET_USER_PROBLEM_DATA,
});
